/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, FormControlLabel, Checkbox, Divider } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const FormAgent = (props) => {
  const history = useHistory();
	const [zPos, setZPos] = useState(45);
  const [disabled, setDisabled] = useState(true);
  const genders = [
    { label: "Masculino", value: "male" },
    { label: "Femenino", value: "female" },
  ];
  const [uuid, setUuid] = useState("");
  const [roles, setRoles] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [features, setFeatures] = useState({ admin: null, script: null, collapsable: null, features: null, commissions: null, crmAdmin: null, afbOps: null, afbRecurringOps: null, crmInbound: null, crmOutbound: null, feeManager: null });
  const [form, setForm] = useState({ gname: "", fname: "", sfname: "", email: "", bdate: new Date(), gender: "", phone: "", bcountry: "", township: "", taxid: "", populationid: "", roles: [""] });
  const [errs, setErrs] = useState({ gname: "", fname: "", sfname: "", email: "", bdate: "", gender: "", phone: "", bcountry: "", township: "", taxid: "", populationid: "", roles: "" });
  useEffect(() => {
    init();
  }, []);

  const init = () => {
    if (props.contentModal.roles) {
      setRoles(JSON.parse(JSON.stringify(props.contentModal.roles.sort((a,b) => (a.label > b.label) ? 1 : -1))));
    }

    if (props.contentModal.agent) {
      let agentInfo = props.contentModal.agent;
      let f = form;
      let er = errs;
      let feat = features

      Object.keys(f).map((item) => {
        if (agentInfo[item]) {
          f[item] = agentInfo[item];
        }
      })
      if (agentInfo.bdate) {
        f.bdate = new Date(agentInfo.bdate);
      }
      if (agentInfo.allRoles) {
        setAllRoles(agentInfo.allRoles);
      }
      Object.keys(feat).map((item) => {
        if (agentInfo[item]) {
          feat[item] = agentInfo[item];
        }
      })

      verifyForm(f, er);
      setUuid(agentInfo.uuid);
      setForm(JSON.parse(JSON.stringify(f)));
      setFeatures(JSON.parse(JSON.stringify(feat)));
    }
  };

  const verifyForm = (data, e) => {
    if ( data.gname &&  data.fname &&  data.email &&  data.bdate &&  data.gender &&  data.phone &&  data.bcountry &&  data.township &&  data.taxid &&  data.populationid &&  data.roles[0] &&
      !e.gname && !e.fname && !e.email && !e.bdate && !e.gender && !e.phone && !e.bcountry && !e.township && !e.taxid && !e.populationid && !e.roles ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const change = async (field, e) => {
    let f = form;
    let er = errs;
    let value = e?.target?.value;

    if(field !== "gname" && field !== "township"){
      value = value?.trim();
    }
    if (field == "bdate") {
      f[field] = new Date(value).toISOString();
    } else if (field == "roles") {
      f["roles"][0] = value;
      if (!value) {
        er["roles"] = "Dato obligatorio";
      } else {
        er["roles"] = "";
      }
    } else if (field == "allRoles") {
      let addRol = allRoles
      
      if(addRol.length === 0){
        addRol.push(f.roles[0])
      }
      if(allRoles.indexOf(e) !== -1){
        addRol.splice(allRoles.indexOf(e), 1)
        setAllRoles(addRol)
      } else {
        addRol.push(e)
        setAllRoles(addRol)
      }
      if(addRol.length === 1){
        addRol.pop()
        setAllRoles(addRol)
      }
    } else if (field == "features") {
      let feat = features

      feat[e] ? feat[e] = false : feat[e] = true 
      if (e === "crmInbound" && feat[e] && feat["crmOutbound"]) {
        feat["crmOutbound"] = false
      }
      if (e === "crmOutbound" && feat[e] && feat["crmInbound"]) {
        feat["crmInbound"] = false
      }
      setFeatures(feat)
    } else {
      if (!value) {
        er[field] = "Dato obligatorio";
      } else {
        er[field] = "";
      }
      f[field] = value;
    }

    verifyForm(f, er);
    setErrs(JSON.parse(JSON.stringify(er)));
    setForm(JSON.parse(JSON.stringify(f)));
  };

  const create = async () => {
    let f = form;
    let names = f.gname.split(" ");
    let alias = `${names[0].toLowerCase()}${f.fname.toLowerCase()}`;
    let feat = features

    let data = {
      gname: f.gname,
      fname: f.fname,
      sfname: f.sfname,
      email: f.email,
      bdate: f["bdate"].toString().substr(0, 10),
      gender: f.gender,
      phone: f.phone,
      bcountry: f.bcountry,
      township: f.township,
      taxid: f.taxid,
      populationid: f.populationid,
      roles: f.roles,
      alias: alias,
    };

    if (props.contentModal?.agent?.allRoles || allRoles.length > 0) {
      data['allRoles'] = allRoles
    }
    Object.keys(feat).map((item) => {
      if ((props.contentModal?.agent && props.contentModal?.agent[item]) || feat[item] !== null) {
        data[item] = feat[item];
      }
    })

    props.changeLoader(true);
		setZPos(-1);

    if (!uuid) {
      let response = await API.service( "createAgent", data, props.pos, props.changeAlert, props.changeLoader, history );

      if (response.status === 200) {
        if (response.data.data.response == "OK") {
          props.changeAlert(true, "success", "Agente creado con éxito");
          await props.reloadData({});
          closelightbox();
        } else {
          props.changeAlert(true, 'error', 'Error al crear agente.');
        }
      }
    }

    if (uuid) {
      let send = {
        uuid: uuid,
        body: data,
      };
			
      let response = await API.service( "updateAgent", send, props.pos, props.changeAlert, props.changeLoader, history );
      if (response.status === 200) {
        if (response.data.data.response == "OK") {
          props.changeAlert(true, "success", "Agente modificado con éxito");
          await props.reloadData({});
          closelightbox();
        } else {
          props.changeAlert(true, 'error', 'Error al crear agente.');
        }
      }
    }
    props.changeLoader(false);
		setZPos(45);
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle >
					{uuid ? "Editar Agente" : "Crear Nuevo Agente"}
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>				
			
				<DialogContent style={{overflowY: "hidden"}}>
					<Grid container spacing={2}>
						<Grid item xs={12} style={{fontWeight: "bolder"}}>
							Datos del agente      
						</Grid>
						<Grid item xs={6}>
							<TextField label="Nombre(s)" value={form.gname} onChange={change.bind(this, "gname")} error={errs.gname !== ""} helperText={errs.gname === "" ? errs.gname : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="Apellido paterno" value={form.fname} onChange={change.bind(this, "fname")} error={errs.fname !== ""} helperText={errs.fname === "" ? errs.fname : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="Apellido materno" value={form.sfname} onChange={change.bind(this, "sfname")} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="Correo electrónico" value={form.email} onChange={change.bind(this, "email")} error={errs.email !== ""} helperText={errs.email ? errs.email : ''} size="small" fullWidth />
						</Grid>
						<Grid item xs={6}>
							<TextField label="CURP" value={form.populationid} onChange={change.bind(this, "populationid")} error={errs.populationid !== ""} helperText={errs.populationid === "" ? errs.populationid : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="RFC" value={form.taxid} onChange={change.bind(this, "taxid")} error={errs.taxid !== ""} helperText={errs.taxid === "" ? errs.taxid : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="Teléfono" value={form.phone} onChange={change.bind(this, "phone")} error={errs.phone !== ""} helperText={errs.phone === "" ? errs.phone : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="País" value={form.bcountry} onChange={change.bind(this, "bcountry")} error={errs.bcountry !== ""} helperText={errs.bcountry === "" ? errs.bcountry : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField label="Ciudad" value={form.township} onChange={change.bind(this, "township")} error={errs.township !== ""} helperText={errs.township === "" ? errs.township : ''} size="small" fullWidth/>
						</Grid>
						<Grid item xs={6}>
							<TextField  
								label="Género" value={form.gender} onChange={change.bind(this, "gender")} select error={errs.gender !== ""} helperText={errs.gender === "" ? errs.gender : ''} size="small" fullWidth  >
								{genders?.map((item, index) => (
									<MenuItem key={`gender-${index}`} value={item.value}>{item.label}</MenuItem>
								))}
							</TextField>
						</Grid>
						<Grid item xs={6}>
							<TextField
								label="Fecha de Nacimiento"
								value={form["bdate"] ? new Date(form["bdate"]).toJSON().substr(0, 10) : form["bdate"]}
								onChange={change.bind(this, "bdate")}
								type={"date"}
								size="small"
								fullWidth
								InputLabelProps={{ shrink: true }}								
							/>
						</Grid>
						<Grid item xs={6}>
							<TextField  
								label="Rol actual" value={form.roles[0]} onChange={change.bind(this, "roles")} select error={errs.roles !== ""} helperText={errs.roles === "" ? errs.roles : ''} size="small" fullWidth  >
								{roles?.map((item, index) => (
									<MenuItem key={`roles-${index}`} value={item.uuid}>{item.label}</MenuItem>
								))}
							</TextField>
						</Grid>
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={4} mt={2}><strong>Roles adicionales</strong></Grid>
              <Grid item xs={8} mt={4}><Divider /></Grid>
            </Grid>
            <Grid container item xs={12}>
              {roles.map((item, index) => {
                return item["uuid"] !== form.roles[0] &&
                (
                  <Grid item xs={6} style={{paddingTop: "0"}}  key={`check-${index}`}>
                    <FormControlLabel control={<Checkbox checked={allRoles.includes(item["uuid"])} onChange={() => change("allRoles", item["uuid"])}/>} label={item["label"]} />
                  </Grid>
                )
              })}
						</Grid>
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={5} mt={2}><strong>Configuraciones adicionales</strong></Grid>
              <Grid item xs={7} mt={4}><Divider /></Grid>
            </Grid>
            <Grid container item xs={12}>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.admin} onChange={() => change("features", "admin")}/>} label={"Administrador"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.script} onChange={() => change("features", "script")}/>} label={"Scripts"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.collapsable} onChange={() => change("features", "collapsable")}/>} label={"Collapsable"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.features} onChange={() => change("features", "features")}/>} label={"Features"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.commissions} onChange={() => change("features", "commissions")}/>} label={"Comisiones"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.crmAdmin} onChange={() => change("features", "crmAdmin")}/>} label={"Master CRM"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.afbOps} onChange={() => change("features", "afbOps")}/>} label={"aFB Ops"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.feeManager} onChange={() => change("features", "feeManager")}/>} label={"Fee Manager"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.crmInbound} onChange={() => change("features", "crmInbound")}/>} label={"CRM Inbound"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.crmOutbound} onChange={() => change("features", "crmOutbound")}/>} label={"CRM Outbound"} />
                </Grid>
                <Grid item xs={6} style={{paddingTop: "0"}}>
                  <FormControlLabel control={<Checkbox checked={features.afbRecurringOps} onChange={() => change("features", "afbRecurringOps")}/>} label={"aFB Opreaciones Recurrentes"} />
                </Grid>
						</Grid>
					</Grid>
				</DialogContent>

				<DialogActions>    
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
					<Button disabled={disabled} variant="contained" onClick={create.bind(this)}>{uuid ? "Editar agente" : "Crear agente"}</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog> 
  );
};

export default FormAgent;
